<ng-container *ngIf="showBanner">
    <app-banner
      [theme]="bannerConfig.theme"
      [title]="bannerConfig.title"
      [description]="bannerConfig.description"
      [buttonText]="bannerConfig.buttonText"
      [buttonUrl]="bannerConfig.buttonUrl"
      [customHandler]="true"
      [customClickHandler]="customButtonClickHandler.bind(this)">
    </app-banner>
</ng-container>

  

  